import { setSnackbar } from '@/slices/components';
import { useDispatch } from '@/store';
import { useCallback } from 'react';

const useModalStatusMessage = () => {
  const dispatch = useDispatch();

  const openModalSuccessMessage = useCallback(
    (message: string) => {
      dispatch(
        setSnackbar({
          open: true,
          message: message,
          severity: 'success',
        }),
      );
    },
    [dispatch],
  );

  const openModalWarningMessage = useCallback(
    (message: string) => {
      dispatch(
        setSnackbar({
          open: true,
          message: message,
          severity: 'warning',
        }),
      );
    },
    [dispatch],
  );

  const openModalErrorMessage = useCallback(
    (message: string) => {
      dispatch(
        setSnackbar({
          open: true,
          message: message,
          severity: 'error',
        }),
      );
    },
    [dispatch],
  );

  return {
    openModalSuccessMessage,
    openModalErrorMessage,
    openModalWarningMessage,
  };
};

export default useModalStatusMessage;
